import { Button, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import { useAudioPlayer } from '@contexts/AudioPlayerContext';
import { PLAYBACK_SPEEDS } from '@constants/config';

export default function PlaybackSpeedSelector() {
  const { playbackRate, setPlaybackRate, currentEpisode } = useAudioPlayer();
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleSelectSpeed = (speed) => {
    setPlaybackRate(speed);
    handleClose();
  };

  const open = Boolean(anchorEl);
  const disabled = !currentEpisode;

  return (
    <>
      <Button
        onClick={handleClick}
        disabled={disabled}
        size="small"
        aria-label={`Playback speed ${playbackRate} times`}
        title="Playback speed"
        sx={{ minWidth: 50 }}
      >
        {playbackRate}x
      </Button>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {PLAYBACK_SPEEDS.map((speed) => (
          <MenuItem
            key={speed}
            selected={speed === playbackRate}
            onClick={() => handleSelectSpeed(speed)}
          >
            {speed}x
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
